const isAbortError = (error) => error?.name === "AbortError";

export default isAbortError;
